// src/components/UploadBox/UploadBox.jsx
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { motion, AnimatePresence } from 'framer-motion';
import { Upload, ImagePlus, RefreshCw, FileImage } from 'lucide-react';
import './UploadBox.css';

function formatBytes(bytes) {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / 1048576).toFixed(1) + ' MB';
}

export default function UploadBox({ image, onUpload }) {
  const onDrop = useCallback((accepted) => {
    if (accepted[0]) onUpload(accepted[0]);
  }, [onUpload]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'image/*': ['.png', '.jpg', '.jpeg', '.webp', '.svg'] },
    maxFiles: 1,
  });

  return (
    <div className="upload-bar">
      {!image ? (
        <motion.div
          {...getRootProps()}
          className={`drop-zone ${isDragActive ? 'drag-active' : ''}`}
          whileHover={{ scale: 1.01 }}
          whileTap={{ scale: 0.99 }}
        >
          <input {...getInputProps()} />
          <Upload size={18} strokeWidth={1.5} />
          <span className="dz-label">
            {isDragActive ? 'Drop it here…' : 'Drop circuit diagram or click to upload'}
          </span>
          <span className="dz-hint">PNG · JPG · SVG · WEBP</span>
        </motion.div>
      ) : (
        <AnimatePresence>
          <motion.div
            className="file-pill"
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <FileImage size={16} />
            <span className="file-name">{image.name}</span>
            <span className="file-size">{formatBytes(image.size)}</span>
            <div {...getRootProps()} className="replace-btn">
              <input {...getInputProps()} />
              <RefreshCw size={13} />
              <span>Replace</span>
            </div>
          </motion.div>
        </AnimatePresence>
      )}
    </div>
  );
}
